export class PackingSlipHistoryModel {
    customerId: number;
    startDate: Date;
    endDate: Date;
}